import { LoadingPage } from '../components/loading/loading-page.component';
import { ParagraphSkeletonLoading } from '../components/loading/skeleton-loading/paragraph-skeleton.component';
import { jsx as _jsx } from "react/jsx-runtime";
export var dynamicNoSsrWithPageLoading = {
  ssr: false,
  loading: function loading() {
    return /*#__PURE__*/_jsx(LoadingPage, {});
  }
};
export var dynamicNoSsrWithSkeleton = {
  ssr: false,
  loading: function loading() {
    return /*#__PURE__*/_jsx(ParagraphSkeletonLoading, {});
  }
};